@defer (on immediate) {
    <div *ngIf="!noDataLoaded" [style.height]="instagramHeight"></div>
}
<ng-container
    [csGamingStoriesModuleLoad]="'InstagramSourceComponent'"
    [data]="data"
    [config]="config"
    (dataNotExistsinsta)="dataNotExistsinstaemit($event)">
</ng-container>
